module.exports = __webpack_public_path__ + "static/media/app-store-w.154f8c26.svg";